import ReportController from './report.controller';

export default class TransportReportController extends ReportController
{
	get endpoint() {
		return 'transport';
	}

	get title() {
		return 'Transport Report';
	}
}



/** WEBPACK FOOTER **
 ** ./resources/assets/js/controllers/transport.report.controller.js
 **/